module.exports = __webpack_public_path__ + "static/media/print-icon.2e1a4d48.svg";